import { SelectDropdownItem } from '../interfaces';

export enum PayoutStatus {
  Blocked = 'blocked',
  Enabled = 'enabled',
  Suspended = 'suspended',
}

export const payoutStatusRecord: Record<PayoutStatus, string> = {
  [PayoutStatus.Enabled]: 'payoutStatuses.enabled',
  [PayoutStatus.Suspended]: 'payoutStatuses.suspended',
  [PayoutStatus.Blocked]: 'payoutStatuses.blocked',
};

export const PAYOUT_STATUS_SELECT_ITEMS: SelectDropdownItem<PayoutStatus>[] = Object.entries(
  payoutStatusRecord,
).map(([value, label]) => ({
  label,
  value: value as PayoutStatus,
}));
